import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 17",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2.667 10.943v2.39h2.39l8-8-2.39-2.39-8 8zm8.471-9.414l3.333 3.333c.26.26.26.682 0 .943L5.805 14.47c-.125.125-.295.196-.472.196H2c-.368 0-.667-.299-.667-.667v-3.333c0-.177.07-.347.196-.472l8.666-8.666c.26-.26.683-.26.943 0z",
			transform: "translate(-315 -282) translate(136 192) translate(171 82) translate(8 8)"
		})
	})
});
export default SvgEdit;
